import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { api } from "../../lib/api";

type Tag = {
  id: number;
  tag: string;
};

type Props = {
  tagIds: number[];
  illustrationId: string;
  onUpdate: () => void;
};

export const TagList = ({ tagIds, illustrationId, onUpdate }: Props) => {
  const [tags, setTags] = useState<Tag[]>([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const all = await api.getTags();
        setTags(all.filter((t) => tagIds.includes(t.id)));
      } catch {
        toast.error("タグの取得に失敗しました");
      }
    };

    if (tagIds.length > 0) {
      fetchTags();
    } else {
      setTags([]);
    }
  }, [tagIds]);

  const handleDeleteTag = async (tagId: number) => {
    const newTagIds = tagIds.filter((id) => id !== tagId);

    try {
      await api.updateIllustration(illustrationId, { tag_ids: newTagIds });
      setTags(tags.filter((tag) => tag.id !== tagId));
      onUpdate();
    } catch (error) {
      console.error(error);
    }
  };

  if (!tags.length) return null;

  return (
    <div className="flex gap-1 flex-wrap">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className="px-2 py-1 bg-white text-xs rounded-full border border-gray-300 text-gray-600 flex items-center gap-1"
        >
          {tag.tag}
          <button
            onClick={() => handleDeleteTag(tag.id)}
            className="hover:text-red-500 transition-colors"
          >
            <XMarkIcon className="w-3 h-3" />
          </button>
        </span>
      ))}
    </div>
  );
};
